module.exports = __webpack_public_path__ + "static/media/predictive.902960e6.jpeg";